import React from "react";

import { TextCenter } from "src/common/components/TextAlign";

import formsGif from "./forms.gif";
import menubarGif from "./menubar.gif";
import mobilGif from "./mobil.gif";
import patientListGif from "./patient_list.gif";
import searchGif from "./search.gif";

export const Change: React.FunctionComponent = () => (
	<section>
		<h1>
			A verzióban több UI/UX (felületi) továbbfejlesztés történt a FYRMS
			rendszer kényelmesebb használhatósága érdekében.
		</h1>
		<p>
			Módosítottunk a táblázatok kinézetén és áthelyezésre került a
			keresés funkció jobb oldalra, mellyel a táblázatokban található
			adatokban lehet keresni.
		</p>
		<TextCenter>
			<img src={patientListGif} width="90%" />
		</TextCenter>
		<p>
			Összecsukhatóvá tettük mind a bal oldali menüsávot, mind pedig a
			jobb oldali űrlap lista panelt az adatok könnyebb olvashatósága
			érdekében.
		</p>
		<TextCenter>
			<img src={menubarGif} width="90%" />
		</TextCenter>
		<p>
			Megszüntettük az űrlapok felugró ablakban történő megjelenítését,
			ezáltal az adatfelvitel kényelmesebben elvégezhető a rendszerben. A
			páciens nevére kattintva pedig visszatérhetünk a Páciens
			adatlapjának kiinduló nézetére.
		</p>
		<TextCenter>
			<img src={formsGif} width="90%" />
		</TextCenter>
		<p>
			Lehetőség van a Páciens adatlapján, annak adatai között történő
			keresésre.
		</p>
		<TextCenter>
			<img src={searchGif} width="90%" />
		</TextCenter>
		<p>
			Az okostelefonokról is egyaránt végezhető gördülékeny munkavégzés
			érdekében további mobil nézet optimalizációkat végeztünk.
		</p>
		<TextCenter>
			<img src={mobilGif} width="50%" />
		</TextCenter>
	</section>
);
